import React, { Component } from "react";
import * as XLSX from "xlsx";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search, CSVExport } from "react-bootstrap-table2-toolkit";
import { articledata, articlecolumns, defaultSorted } from "./TableInformation";

import "./_datatable.scss";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";

class CardLessDataTableWithSearch extends Component {
  constructor() {
    super();
  }

  exportToExcel = (data) => {
    const { particlecolumns, name } = this.props;

    // Map column data for SheetJS
    const visibleColumns = particlecolumns.filter(col => col.dataField);
    const headerRow = visibleColumns.map(col => col.text);
    
    const dataRows = data.map(item => 
      visibleColumns.map(col => {
        let val = item[col.dataField];
        // Handle formatters if needed (e.g. for fixing decimal places)
        if (typeof col.formatter === 'function' && (col.dataField.includes('avg') || col.dataField.includes('Score'))) {
           // Basic numeric formatting for Excel to match UI
           return val !== null && val !== undefined ? Number(val).toFixed(2) : "-";
        }
        return val;
      })
    );

    const worksheet = XLSX.utils.aoa_to_sheet([headerRow, ...dataRows]);

    // Set Column Widths
    const colWidths = visibleColumns.map(col => {
      const text = col.text.toLowerCase();
      if (text.includes("exam")) return { wch: 40 };
      if (text.includes("name") || text.includes("branch") || text.includes("city")) return { wch: 25 };
      if (text.includes("score") || text.includes("avg")) return { wch: 15 };
      return { wch: 12 };
    });
    worksheet["!cols"] = colWidths;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `${name || "Report"}.xlsx`);
  };

  render() {
    console.log("Table Props", this.props);

    //  console.log("this.props.particlecolumns", this.props.particlecolumns);
    // console.log("articlecolumns", articlecolumns);
    const customTotal = (from, to, size) => (
      <span className="ml-2 react-bootstrap-table-pagination-total">
        Showing {from} to {to} of {size} Results
      </span>
    );
    const { SearchBar } = Search;
    const { ExportCSVButton } = CSVExport;

    const options = {
      paginationSize: 5,
      pageStartIndex: 1,
      // alwaysShowAllBtns: true, // Always show next and previous button
      withFirstAndLast: false, // Hide the going to First and Last page button
      // hideSizePerPage: true, // Hide the sizePerPage dropdown always
      // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
      firstPageText: "First",
      prePageText: "Previous",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      showTotal: true,
      paginationTotalRenderer: customTotal,
      sizePerPageList: [
        {
          text: "10",
          value: 10
        },
        {
          text: "25",
          value: 25
        },
        {
          text: "50",
          value: 50
        },
        {
          text: "All",
          value: this.props.parentData.length
        }
      ] // A numeric array is also available. the purpose of above example is custom the text
    };

    const contentTable = ({ paginationTableProps }) => (
      <ToolkitProvider
        keyField="id"
        data={this.props.parentData}
        columns={this.props.particlecolumns}
        defaultSorted={this.props.defaultSorted}
        search
        exportCSV={{
          fileName: `${this.props.name || 'report'}.csv`,
          noAutoBOM: false,
          onlyExportFiltered: true,
          exportAll: true
        }}
        bootstrap4
      >
        {toolkitprops => {
          console.log("Table", toolkitprops);

          return (

            <div>
              <div className="d-flex justify-content-between align-items-center mb-2">
                {
                  this.props.searchBar == false ?
                    ("")
                    : (<div className="inputWidthCls">
                      <SearchBar {...toolkitprops.searchProps} placeholder={this.props.name == "hostel_attendance" ? "Search" : this.props.name != undefined ? "Search Student" : "Search Question"} />
                    </div>)
                }
                {window.location.pathname.includes("/ExamReport_tabs") &&
                  <i 
                    className="fa fa-download mr-1 cursor-pointer text-muted hover-blue" 
                    onClick={() => this.exportToExcel(toolkitprops.baseProps.data)}
                    title="Download Excel"
                  ></i>
                }
              </div>

              <BootstrapTable
                defaultSorted={this.props.defaultSorted}
                bordered={false}
                wrapperClasses="table-responsive fontWeightTDs table-bordered"
                {...toolkitprops.baseProps}
                {...paginationTableProps}
              />

            </div>
          );
        }}
      </ToolkitProvider>
    );

    return (
      <PaginationProvider pagination={paginationFactory(options)}>
        {contentTable}
      </PaginationProvider>
    );
  }
}

export default CardLessDataTableWithSearch;
